import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-countrycheck',
  templateUrl: './countrycheck.component.html',
  styleUrls: ['./countrycheck.component.scss']
})
export class CountrycheckComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<CountrycheckComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
  }
  onNoClick(): void {
    this.dialogRef.close('no');
  }
}
